// V2 KP Rebuild : galerie de fiche produit. Défilement natif (scroll-snap) : glissement au doigt, flèches,
// miniatures, points, flèches du clavier. Suit la variante choisie par l'événement v2:variant-change (paliers V2)
// et par l'événement variantChange de Dawn (sélecteur natif).
// S32 (liste de médias, data-list) :
// - data-filter « Option=Valeur » : le média n'est visible que pour cette valeur (jeux Blanc / Noir du Wind Chaser) ;
// - data-link « Option=Valeur » : la galerie va sur ce média quand l'option prend cette valeur (voiture, modèle) ;
// - le seul changement de pack ne déplace pas la galerie ; data-initial="lien" (S33) : ouverture sur le média lié ; data-packs = principale | voiture règle les packs 2 et 3 ;
// - vidéos : jamais en lecture automatique ; lecture au clic, pause quand la diapositive est quittée.
const pairs = (s) => (s || '').split('&').map((p) => p.split('=')).filter((p) => p.length === 2).map(([k, v]) => [k.trim(), v.trim()]);

if (!customElements.get('v2-gallery')) {
  customElements.define(
    'v2-gallery',
    class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.v2-gallery__piste');
        this.all = [...this.querySelectorAll('.v2-gallery__slide')];
        this.dots = [...this.querySelectorAll('.v2-gallery__point')];
        this.minis = [...this.querySelectorAll('.v2-gallery__mini')];
        this.counter = this.querySelector('[data-v2-compteur]');
        this.index = 0;
        if (!this.track || this.all.length === 0) return;
        this.slides = this.all;
        this.list = this.dataset.list === 'true';
        this.sectionId = this.dataset.section;
        this.sep = ' + ';
        try { this.names = JSON.parse(this.dataset.optionNames || '[]'); } catch (e) { this.names = []; }

        this.querySelectorAll('[data-v2-prev]').forEach((b) => b.addEventListener('click', () => this.go(this.index - 1)));
        this.querySelectorAll('[data-v2-next]').forEach((b) => b.addEventListener('click', () => this.go(this.index + 1)));
        this.querySelectorAll('[data-v2-go]').forEach((b) => b.addEventListener('click', () => this.goAbs(Number(b.dataset.v2Go))));
        this.querySelectorAll('[data-v2-play]').forEach((b) => b.addEventListener('click', () => this.play(b.closest('[data-v2-video]'))));
        this.addEventListener('keydown', (e) => {
          if (e.target.closest('video')) return;
          if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(this.index - 1); }
          if (e.key === 'ArrowRight') { e.preventDefault(); this.go(this.index + 1); }
        });

        let raf = 0;
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(raf);
          raf = requestAnimationFrame(() => this.syncFromScroll());
        }, { passive: true });

        this.onVariant = (event) => {
          const d = event.detail || {};
          if (d.sectionId && this.sectionId && d.sectionId !== this.sectionId) return;
          const variant = d.variant;
          if (!variant) return;
          if (this.list) { this.applyVariant(variant.options || [], d.car || null); return; }
          const mediaId = variant.featured_media?.id || variant.media;
          if (mediaId) this.goToMedia(String(mediaId));
        };
        document.addEventListener('v2:variant-change', this.onVariant);
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsub = subscribe(PUB_SUB_EVENTS.variantChange, (e) => this.onVariant({ detail: { variant: e.data?.variant } }));
        }

        if (this.list) {
          let initial = [];
          try { initial = JSON.parse(this.dataset.initialOptions || '[]'); } catch (e) { /* aucune variante */ }
          this.prev = null;
          this.applyVariant(initial, null, true);
        } else {
          this.go(Number(this.dataset.start || 0), true);
        }
      }

      disconnectedCallback() {
        document.removeEventListener('v2:variant-change', this.onVariant);
        if (this.unsub) this.unsub();
      }

      value(options, name) {
        const i = this.names.indexOf(name);
        return i >= 0 ? options[i] : undefined;
      }

      matches(slide, attr, options) {
        const p = pairs(slide.dataset[attr]);
        return p.length > 0 && p.every(([k, v]) => this.value(options, k) === v);
      }

      // jeu visible selon les filtres, puis destination : lien correspondant à l'option changée, sinon rien
      applyVariant(options, car, initial = false) {
        const visible = this.all.filter((s) => !s.dataset.filter || this.matches(s, 'filter', options));
        const changedSet = !this.slides || visible.length !== this.slides.length || visible.some((s, i) => s !== this.slides[i]);
        if (changedSet || initial) this.setVisible(visible);
        const prev = this.prev;
        this.prev = options;

        const linked = (name, val) => this.slides.findIndex((s) => pairs(s.dataset.link).some(([k, v]) => k === name && v === val));
        let target = -1;
        if (initial || changedSet) {
          // ouverture de la fiche ou nouveau jeu : 1er média du jeu ; avec data-initial="lien" (S33), à l'ouverture,
          // média lié à une option de la variante sélectionnée (coloris, modèle) s'il existe
          if (initial && this.dataset.initial === 'lien') this.names.forEach((n, i) => { if (target < 0) target = linked(n, options[i]); });
          this.go(target >= 0 ? target : 0, true);
          return;
        }
        if (car) {
          // sélecteur #n d'un pack 2 ou 3
          const multi = String(this.value(options, 'Voitures') || '').includes(this.sep);
          target = multi && this.dataset.packs === 'principale' ? 0 : linked('Voitures', car);
        } else if (prev) {
          this.names.forEach((n, i) => {
            if (target >= 0 || options[i] === prev[i]) return;
            const t = linked(n, options[i]);
            if (t >= 0) target = t;
            else if (n === 'Voitures' && this.dataset.packs === 'principale' && String(options[i]).includes(this.sep)) target = 0;
          });
        }
        if (target >= 0) this.go(target);
      }

      setVisible(visible) {
        this.pause();
        this.slides = visible;
        this.all.forEach((s, k) => {
          const on = visible.includes(s);
          s.hidden = !on;
          if (this.dots[k]) this.dots[k].hidden = !on;
          if (this.minis[k]) this.minis[k].parentElement.hidden = !on;
        });
        this.slides.forEach((s, i) => s.setAttribute('aria-label', `Média ${i + 1} sur ${this.slides.length}`));
        this.dots.forEach((d) => { const s = this.all[Number(d.dataset.v2Go)]; if (s) d.setAttribute('aria-label', `Média ${visible.indexOf(s) + 1}`); });
        this.toggleAttribute('data-single', visible.length < 2);
      }

      goAbs(k) {
        const i = this.slides.indexOf(this.all[k]);
        if (i >= 0) this.go(i);
      }

      goToMedia(mediaId) {
        const i = this.slides.findIndex((s) => s.dataset.mediaId === mediaId);
        if (i >= 0) this.go(i);
      }

      go(i, instant = false) {
        const n = this.slides.length;
        if (!n) return;
        const target = Math.max(0, Math.min(n - 1, i));
        const slide = this.slides[target];
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollTo({ left: slide.offsetLeft - this.track.offsetLeft, behavior: instant || reduce ? 'auto' : 'smooth' });
        this.setActive(target);
      }

      syncFromScroll() {
        const left = this.track.scrollLeft;
        let best = 0; let dist = Infinity;
        this.slides.forEach((s, i) => {
          const d = Math.abs(s.offsetLeft - this.track.offsetLeft - left);
          if (d < dist) { dist = d; best = i; }
        });
        if (best !== this.index) this.setActive(best);
      }

      setActive(i) {
        if (i !== this.index) this.pause();
        this.index = i;
        const n = this.slides.length;
        const abs = this.all.indexOf(this.slides[i]);
        this.dots.forEach((d, k) => d.setAttribute('aria-current', k === abs ? 'true' : 'false'));
        this.minis.forEach((m, k) => m.setAttribute('aria-current', k === abs ? 'true' : 'false'));
        this.querySelectorAll('[data-v2-prev]').forEach((b) => { b.disabled = i === 0; });
        this.querySelectorAll('[data-v2-next]').forEach((b) => { b.disabled = i === n - 1; });
        const mini = this.minis[abs];
        if (mini) {
          const list = mini.closest('.v2-gallery__mini-liste');
          if (list) list.scrollTo({ left: mini.parentElement.offsetLeft - list.offsetLeft - (list.clientWidth - mini.clientWidth) / 2, behavior: 'auto' });
        }
        if (this.counter) this.counter.textContent = `Média ${i + 1} sur ${n}`;
        this.dataset.index = String(i);
        this.dataset.media = this.slides[i]?.dataset.mediaId || '';
      }

      play(box) {
        const v = box?.querySelector('video');
        if (!v) return;
        v.controls = true;
        box.classList.add('is-playing');
        v.play().catch(() => { /* lecture refusée : les contrôles natifs restent disponibles */ });
      }

      pause() {
        this.querySelectorAll('[data-v2-video] video').forEach((v) => { if (!v.paused) v.pause(); });
      }
    }
  );
}
